import React, { useState, useEffect } from 'react';
import AdminDashboard from './AdminDashboard';
import Swal from 'sweetalert2';
import '../../assets/css/admin/allcourses.css';

const AllIntSchls = () => {
    const [internationalSchools, setInternationalSchools] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchInternationalSchools();
    }, []);

    const fetchInternationalSchools = async () => {
        try {
            const response = await fetch('https://api.myskills.lk/internationalSchools/all');
            const data = await response.json();
            setInternationalSchools(data);
        } catch (error) {
            console.error('Error fetching international schools:', error);
        }
    };

    const handleDelete = async (schoolId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to delete this international school?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/internationalSchools/delete/${schoolId}`, {
                        method: 'POST'
                    });
                    if (response.ok) {
                        // Update local state after successful deletion
                        const updatedSchools = internationalSchools.filter(school => school.id !== schoolId);
                        setInternationalSchools(updatedSchools);
                        
                        // Show success message
                        Swal.fire({
                            title: "Deleted!",
                            text: "The international school has been deleted.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to delete international school');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to delete the international school.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error deleting international school:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to delete the international school.",
                        icon: "error"
                    });
                }
            }
        });
    };

    // Filter international schools based on search term
    const filteredIntSchools = internationalSchools.filter(school => 
        (school.intschlName && school.intschlName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (school.commonPhone && school.commonPhone.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (school.commonEmail && school.commonEmail.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (school.website && school.website.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const handleSearchSubmit = (e) => {
        e.preventDefault(); // Prevent form submission
    };

    return (
        <div>
            <AdminDashboard />
            <div className='AllViews-admin-course'>
                <div className="search-icon-admin admin-course-search">
                    <h1>ALL INTERNATIONAL SCHOOLS</h1>
                    <form onSubmit={handleSearchSubmit}>
                        <input 
                            type="text" 
                            placeholder='Search Item' 
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <input type="submit" value="SEARCH" />
                    </form>
                </div>
                <div className="scroller-box">
                    <div className="table-course">
                        <table>
                            <thead>
                            <tr>
                                    <th>School Name</th>
                                    <th>Contact Person</th>
                                    <th>Email</th>
                                    <th>View</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                            {filteredIntSchools.map((school) => (
                                <tr key={school.id}>
                                    <td>{school.intschlName}</td>
                                    <td>{school.commonPhone}</td>
                                    <td>{school.commonEmail}</td>
                                        <td>
                                            <a href={school.website} target="_blank" rel="noopener noreferrer">
                                                Visit Website
                                            </a>
                                        </td>
                                        <td id='action-buttons'>
                                            <a href="#!" id='del-details' onClick={() => handleDelete(school.id)}>DELETE</a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AllIntSchls;
